/*
 * @Author: tong.kai
 * @Date: 2020/9/16 17:18
 * @FilePath: D:\Files\新疆项目\新疆日报前端项目\xjmediacloud\app\manageConfig\tenantManageMent\service\bindTip\bindTip.js
 * @Description:  绑定账号输入账号密码弹框
 */
'use strict';
angular.module('setBillingBindTipModule', [])
    .controller('setBillingBindTipCtrl', ['$scope', '$q', '$modalInstance', 'item', 'trsHttpService', 'modalDialog', '$validation',
        function($scope, $q, $modalInstance, item, trsHttpService, modalDialog, $validation) {
            initStatus();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    userName: '',
                    phoneNumber: '',
                };
                $scope.newsForm = [];
                $scope.isShowTip = true;
            }

            /** [cancel description]关闭弹窗 */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            $scope.confirm = function() {
                // modalDialog.alertType('绑定成功', '', 'success', false, function() {
                //     $modalInstance.close('aaa');
                // });
                $validation.validate($scope.textDesignationForm).success(function() {
                    var params = {
                        serviceid: 'mlf_eqxiuaccount',
                        methodname: 'registerEqxiuEnterpriseSubAccount',
                        phoneNumber: $scope.data.phoneNumber,
                        nickName: $scope.data.userName,
                        tenantId: item.TENANTID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $modalInstance.close();
                        // modalDialog.alertType('绑定成功', '', 'success', false, function() {
                        //     $modalInstance.close();
                        // });
                    });
                });

            };

            $scope.showTip = function() {
                $scope.isShowTip = true;
            };
            $scope.hideTip = function() {
                $scope.isShowTip = false;
            };
        },
    ]);
